import { getGridStringOperators } from '@mui/x-data-grid';

export const getStringEqualsOperator = () => getGridStringOperators().find((op) => op.value === 'equals')!;
